import React, { createContext, useContext, useState, useEffect } from 'react';

const UserInteractionContext = createContext<boolean>(false);

export const UserInteractionProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    const handleInteraction = () => {
      setHasInteracted(true);
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('mousedown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };

    window.addEventListener('scroll', handleInteraction);
    window.addEventListener('mousedown', handleInteraction);
    window.addEventListener('touchstart', handleInteraction);

    return () => {
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('mousedown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  return (
    <UserInteractionContext.Provider value={hasInteracted}>
      {children}
    </UserInteractionContext.Provider>
  );
};

export const useUserInteraction = () => useContext(UserInteractionContext);
